export default "__VITE_ASSET__CZlwkQDy__"